module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header clearfix"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "login hide-in-mobile"
  }, [(!_vm.isLogin) ? _c('a', {
    staticClass: "log",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v("登录")]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    staticClass: "reg",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showReg
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v("注册")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "person hide-in-mobile"
  }, [(_vm.isLogin) ? _c('Dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('a', {
    staticClass: "name",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.member.name) + "   "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', [_c('router-link', {
    attrs: {
      "to": "/personal"
    }
  }, [_vm._v("个人中心")])], 1), _vm._v(" "), _c('DropdownItem', [_c('a', {
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出")])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "search hide-in-mobile"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchIsReady),
      expression: "searchIsReady"
    }],
    staticClass: "search-target",
    staticStyle: {
      "width": "74px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.searchTarget),
      callback: function($$v) {
        _vm.searchTarget = $$v
      },
      expression: "searchTarget"
    }
  }, [_c('Option', {
    attrs: {
      "value": "statute"
    }
  }, [_vm._v("法规")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "news"
    }
  }, [_vm._v("新闻")])], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-ipt",
    class: {
      'is-active': _vm.searchIsReady
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('Icon', {
    attrs: {
      "type": "search",
      "size": "20",
      "color": "#15ccac"
    }
  })], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.$route.path == '/') ? _c('h1', [_vm._v("国际药品注册网")]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.$route.path != '/' ? '国际药品注册网' : '') + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "nav hide-in-mobile"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    class: {
      'is-active': _vm.$route.path == '/'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    staticClass: "cascader",
    class: {
      'is-active': _vm.$route.path == '/statute'
    }
  }, [_c('Cascader', {
    attrs: {
      "data": _vm.categoryList.children,
      "trigger": "hover"
    },
    on: {
      "on-change": _vm.getLinkParam
    },
    model: {
      value: (_vm.link),
      callback: function($$v) {
        _vm.link = $$v
      },
      expression: "link"
    }
  }, [_c('a', [_vm._v("注册法规")])])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': (_vm.$route.path == '/questions' || _vm.$route.path == '//term-content')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/questions'
      }
    }
  }, [_vm._v("问与答")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': (_vm.$route.path == '/term' || _vm.$route.path == '/term-content')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/term'
      }
    }
  }, [_vm._v("术语学习")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.path == '/news'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/news'
      }
    }
  }, [_vm._v("新闻资讯")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.path == '/business'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/business'
      }
    }
  }, [_vm._v("业务服务")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.path == '/codex'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/codex'
      }
    }
  }, [_vm._v("数据库")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.curIndex == 7
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      }
    }
  }, [_vm._v("关于我们")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hide hamburger show-in-mobile",
    on: {
      "click": function($event) {
        _vm.trans_in = true
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon-round",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search show-in-mobile"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchIsReady),
      expression: "searchIsReady"
    }],
    staticClass: "search-target",
    staticStyle: {
      "width": "74px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.searchTarget),
      callback: function($$v) {
        _vm.searchTarget = $$v
      },
      expression: "searchTarget"
    }
  }, [_c('Option', {
    attrs: {
      "value": "statute"
    }
  }, [_vm._v("法规")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "news"
    }
  }, [_vm._v("新闻")])], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-ipt",
    class: {
      'is-active': _vm.searchIsReady
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('Icon', {
    attrs: {
      "type": "search",
      "size": "20",
      "color": "#15ccac"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "show-in-mobile"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.trans_in),
      expression: "trans_in"
    }],
    staticClass: "nav-layout",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.trans_in = false
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.trans_in) ? _c('div', {
    staticClass: "aside-nav"
  }, [(!_vm.isLogin) ? _c('div', {
    staticClass: "aside-login"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "ghost",
      "long": ""
    },
    on: {
      "click": _vm.showReg
    }
  }, [_vm._v("注册")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "aside-login"
  }, [_c('Avatar', {
    staticStyle: {
      "color": "#fff",
      "background-color": "#15ccac",
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "size": "large"
    }
  }, [_vm._v(_vm._s(_vm.member.name))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/personal"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    }
  }, [_vm._v("个人中心")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "ghost",
      "long": ""
    },
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aside-menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('ul-tree', {
    staticClass: "aside-sub-nav-menu",
    attrs: {
      "data": _vm.categoryList
    },
    on: {
      "transform": _vm.toggle
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/questions'
      }
    }
  }, [_vm._v("问与答")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/term'
      }
    }
  }, [_vm._v("术语学习")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/news'
      }
    }
  }, [_vm._v("新闻资讯")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/business'
      }
    }
  }, [_vm._v("业务服务")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/codex'
      }
    }
  }, [_vm._v("数据库")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      }
    }
  }, [_vm._v("关于我们")])], 1)])])]) : _vm._e()])], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268c13bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 487
// module chunks = 15